import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

const crud = (resource) => ({
  list: async (params) => (await http.get(`/${resource}`, { params })).data,
  create: async (data) => (await http.post(`/${resource}`, data)).data,
  update: async (id, data) => (await http.put(`/${resource}/${id}`, data)).data,
  remove: async (id) => (await http.delete(`/${resource}/${id}`)).data,
});

export const sessionsApi = crud("sessions");
export const speakersApi = crud("speakers");
export const agendaApi = crud("agenda-items");
